import api from '../services/api';
import { $Qll, $Q } from '../utils/querySelector';
import { stringToHTML } from '../utils/toHtml';
import { RefreshPage } from './preorderVariant';
import { currentLang } from '../utils/getLanguage';
import { redirect } from '../utils/redirect';

/**
 * Product functionalities
 * @author Michael Ballen <michael.ballen@gradiweb.com>
 */
class Product {
  constructor(query, linksquery, engraving) {
    this.productDescription = $Q(query);
    this.linksContainer = $Q(linksquery);
    this.engravingBtn = document.querySelectorAll(engraving);
    this.stickyNav = $Q('.nav-sticky');

    if (this.productDescription) {
      this._init();
    }

    if (this.stickyNav) {
      const selectVariants = $Q('select[name="id"]', this.stickyNav);

      document.querySelectorAll('.nav-sticky a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', this._smoothScrollWithOffset);
      });

      if (selectVariants) selectVariants.addEventListener('change', function (e) {
        const option = e.target.selectedOptions[0]
        document.querySelector('.atc-component__price').textContent = option.dataset.price
        document.querySelector('.atc-component__compare-at-price').textContent = option.dataset.compare || ''
        if (option.dataset.compare) document.querySelector('.atc-component__compare-at-price').removeAttribute('hidden')
        else document.querySelector('.atc-component__compare-at-price').setAttribute('hidden', '')
      })
    }

    if ($Q('#MainContent')) {
      this.addCurrentLang();
    }

    if ($Qll('.js-prod-card-btn-klaviyo')) {
      /* this.redirectProductCardToProduct(); */
    }
    if (this.engravingBtn) {
      this._tooggleEngraving();
    }
  }

  /**
     * Init prouct characters for description
     * @author Michael Ballen <michael.ballen@gradiweb.com>
     */
  _init() {
    this._countCharacters();
    this._validateLinks();
    this._validateSwiper();
  }

  /**
   * Validate if product description have a long description
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   * @see _readMore()
   */
  _countCharacters() {
    const fullDescription = this.productDescription.innerHTML;
    if (fullDescription.includes('<p>...</p>')) {
      this._readMore(fullDescription);
    }
  }

  _validateLinks() {
    const dowloadLink = $Q(
      '#product__description-dowload-link',
      this.linksContainer
    );
    const specLink = $Q('#product__description-spec-link', this.linksContainer);

    if (dowloadLink != null) {
      const dowloadAccordion = $Q('#dowloads');

      if (dowloadAccordion === null) {
        dowloadLink.classList.add('hidden');
      }
    }

    if (specLink != null) {
      const specAccordion = $Q('#spec');

      if (specAccordion === null) {
        specLink.classList.add('hidden');
      }
    }
  }

  /**
   * Enable link for extend description
   * @param {String} string
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   * @see _showHiddeText()
   */
  _readMore(string) {
    const descriptions = string.split('<p>...</p>');
    const descriptionPreview = descriptions[0];
    const description2 = descriptions[1];
    const readMoreText = $Q('#read-more-text').value;
    const readlessText = $Q('#read-less-text').value;

    this.productDescription.innerHTML = `
      ${descriptionPreview}
      <span id="more" class="more">${description2}</span>
      <span id="dots" class="dots">${readMoreText}</span>
    `;

    const readMoreButton = $Q('#dots');
    const secondDescription = $Q('#more');

    // show other botton when this is clicked
    readMoreButton.addEventListener(
      'click',
      this._showHiddeText.bind(
        this,
        readMoreButton,
        secondDescription,
        readMoreText,
        readlessText
      )
    );
  }

  /**
   * Extend all description and change text for the link
   * @param {Node} button
   * @param {Node} text
   * @param {String} readMoreText
   * @param {String} readlessText
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   */
  _showHiddeText(button, text, readMoreText, readlessText) {
    text.classList.toggle('more-show');

    if (text.classList.contains('more-show')) {
      button.innerText = readlessText;
    } else {
      button.innerText = readMoreText;
    }
  }

  /**
   * Render in DOM if selected variant have stock
   * @param {String} variantInfo
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   */
  _changeStockMessage(variantInfo) {
    const elements = {
      validateVariant: $Q('#validate-stock', stringToHTML(variantInfo)),
      validateContainer: $Q('#validate-stock'),
      stockElement: $Q('.product__description--price-stock'),
      stockText: $Q('#stock-text')
    };

    if (!elements.validateVariant || !elements.validateContainer || !elements.stockElement) {
      return;
    }

    const stockData = {
      message: elements.validateVariant.getAttribute('data-stock-text'),
      isInStock: elements.validateVariant.getAttribute('data-stock') === 'true'
    };

    elements.stockElement.classList.toggle('in_stock', stockData.isInStock);
    elements.stockElement.classList.toggle('out_stock', !stockData.isInStock);

    elements.stockText.innerText = stockData.message;

  }

  /**
   * Render in DOM the selected variant price
   * @param {String} variantInfo
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   */
  _changeVariantPrice(variantInfo) {
    const priceContainer = $Q(
      '.product__description--price-prices',
      stringToHTML(variantInfo)
    );
    const priceContainerDom = $Q('.product__description--price-prices');
    const stickyPriceContainer = $Q(
      '.stickyaddcart__product-price',
      stringToHTML(variantInfo)
    );
    const stickyPriceContainerDom = $Q('.stickyaddcart__product-price');

    priceContainerDom.innerHTML = priceContainer.innerHTML;
    if (stickyPriceContainerDom) {
      stickyPriceContainerDom.innerHTML = stickyPriceContainer.innerHTML;
    }
  }

  _changeButton(variantInfo) {
    const buttonContainer = $Q(
      '.product__description--variantform-button',
      stringToHTML(variantInfo)
    );
    const buttonContainerDom = $Q('.product__description--variantform-button');
    const stickyButtonContainer = $Q(
      '.stickyaddcart__buttons',
      stringToHTML(variantInfo)
    );
    const stickyButtonContainerDom = $Q('.stickyaddcart__buttons');

    buttonContainerDom.innerHTML = buttonContainer.innerHTML;
    if (stickyButtonContainerDom) {
      stickyButtonContainerDom.innerHTML = stickyButtonContainer.innerHTML;
    }

    document.querySelectorAll('span.engraving__event').forEach((btn) => {
      btn.addEventListener('click', () => {
        const modalEngraving = document.querySelector('#modal-engraving');
        modalEngraving.classList.contains('active')
          ? modalEngraving.classList.remove('active')
          : modalEngraving.classList.add('active');
      });
    });
  }

  /**
   * Render in DOM the selected variant image in slider
   * @param {String} variantInfo
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   */
  _changeImageSlider(variantInfo) {
    const sliderContainer = $Q(
      '.product__slider .swiper-wrapper',
      stringToHTML(variantInfo)
    );
    const sliderContainerDom = $Q('.product__slider .swiper-wrapper');
    const stickyImage = $Q(
      '.stickyaddcart__product-info',
      stringToHTML(variantInfo)
    );
    const stickyImageDom = $Q('.stickyaddcart__product-info');

    sliderContainerDom.innerHTML = sliderContainer.innerHTML;
    if (stickyImageDom) {
      stickyImageDom.innerHTML = stickyImage.innerHTML;
    }
  }

  /**
   * Get the HTML section from selected variant
   * @param {String} variantId
   * @param {String} handle
   * @author Michael Ballen <michael.ballen@gradiweb.com>
   * @see _changeImageSlider()
   * @see _changeStockMessage()
   * @see _changeVariantPrice()
   */
  async getVariantInfo(variantId, handle) {
    const base = `/products/${handle}?variant=${variantId}`;
    this.enableLoader();
    const response = await api.shopifySectionByUrl(base, 'main-product');

    this._changeStockMessage(response);
    this._changeVariantPrice(response);
    this._changeImageSlider(response);
    this._changeButton(response);
    this.disabledLoader();
    this.changeSelectValue();
    RefreshPage();
  }

  /**
   * Add attribute to the tag main with the current laguange
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  addCurrentLang() {
    const main = $Q('#MainContent');
    main.setAttribute('data-isLang', currentLang);
    main.setAttribute('data-isLang', currentLang);
  }

  /**
   * Redirect product card to the product page when button is "Notify me".
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  redirectProductCardToProduct() {
    $Qll('.js-prod-card-btn-klaviyo').forEach((btn) => {
      btn.addEventListener('click', () => redirect(`${btn.dataset.href}`));
    });
  }

  enableLoader() {
    const loaders = $Qll('.loading-overlay');
    const stickyImage = $Q('.stickyaddcart__product-info--img');
    const stickyVariants = $Q(
      '.stickyaddcart__variant-selector .add-cart-form'
    );

    loaders.forEach((loader) => {
      loader.classList.remove('hidden');
    });

    if (stickyImage) {
      stickyImage.classList.add('hidden');
    }
    if (stickyVariants) {
      stickyVariants.classList.add('hidden');
    }
  }

  disabledLoader() {
    const loaders = $Qll('.loading-overlay');
    const stickyVariants = $Q(
      '.stickyaddcart__variant-selector .add-cart-form'
    );

    loaders.forEach((loader) => {
      loader.classList.add('hidden');
    });

    if (stickyVariants) {
      stickyVariants.classList.remove('hidden');
    }
  }

  changeSelectValue() {
    const select = $Q('.variants--select-tag[name="Colour"]');
    const value =
      $Q(
        '.variant_radio-button--design span',
        $Q('.stickyaddcart__container')
      ) &&
      $Q('.variant_radio-button--design span', $Q('.stickyaddcart__container'))
        .dataset.selectedColor;

    if (value) {
      const colorVariant = $Q(
        `.option_${value.toLowerCase()}`,
        $Q('.product__description--variantform')
      );

      select.value = value;
      colorVariant.click();
    }
  }

  /**
   * Validate if the points of the slider are greater than one
   * @author Sebastián García <sebastian.garcia@gradiweb.com>
   */
  _validateSwiper() {
    const sliderPrincipal = $Qll('.main-product__slider-principal');
    const productSlider = $Qll('.product-slider');

    if (!sliderPrincipal) return;
    const swiperPagination = $Qll('.swiper-pagination', sliderPrincipal[0])[0];
    if (swiperPagination?.children?.length <= 1) {
      swiperPagination.classList.add('hidden');
      $Qll('.swiper-button-next', productSlider[0])[0].classList.add('hidden');
      $Qll('.swiper-button-prev', productSlider[0])[0].classList.add('hidden');
    }
  }

  /**
   * Open engraving
   * @author Miguel Camacho <miguel.camacho@gradiweb.com>
   */
  _tooggleEngraving() {
    const modalEngraving = document.querySelector('#modal-engraving');

    this.engravingBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        modalEngraving.classList.contains('active')
          ? modalEngraving.classList.remove('active')
          : modalEngraving.classList.add('active');
      });
    });
  }

  /**
   * Smooth scroll with offset
   * @author Miguel Camacho <camilosaenz115@gmail.com>
   */

  _smoothScrollWithOffset(event) {
    event.preventDefault();

    const targetId = event.currentTarget.getAttribute('href');
    const targetElement = document.querySelector(targetId);

    document.querySelectorAll('.nav-sticky li.active').forEach(el => {
      el.classList.remove('active');
    });

    event.currentTarget.closest('li').classList.add('active');

    const navHeight = document.querySelector('.nav-sticky').offsetHeight;

    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - navHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

}

export { Product };
